import { render, staticRenderFns } from "./MangaRankList.vue?vue&type=template&id=5b3495b8&scoped=true&"
import script from "./MangaRankList.vue?vue&type=script&lang=js&"
export * from "./MangaRankList.vue?vue&type=script&lang=js&"
import style0 from "./MangaRankList.vue?vue&type=style&index=0&id=5b3495b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3495b8",
  null
  
)

export default component.exports